import { render, staticRenderFns } from "./_reset-password.vue?vue&type=template&id=5832e2c9"
import script from "./_reset-password.vue?vue&type=script&lang=js"
export * from "./_reset-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports